var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"no-underline",attrs:{"href":"https://tozny.com/contact","target":"_blank"}},[_c('ToznyButton',{staticClass:"banner-button mb-0 ml-4 focus:outline-none active:outline-none",attrs:{"id":"contact-sales-button-in-banner","buttonText":"Contact Sales"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }